import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { datadogRum } from "@datadog/browser-rum";
import { Button } from "semantic-ui-react";

import EmbedVideo from "../EmbedVideo";

function VideoGallery({ videos, width, height, initialIndex }) {
  const [currentIndex, setCurrentIndex] = useState(
    Math.max(0, Math.min(initialIndex, videos.length - 1))
  );

  const navigateTo = useCallback(
    (action) => {
      return () => {
        setCurrentIndex((prev) => {
          if (action === "prev" && prev > 0) return prev - 1;
          if (action === "next" && prev < videos.length - 1) return prev + 1;
          return prev;
        });
      };
    },
    [videos.length]
  );

  useEffect(() => {
    if (videos?.length)
      datadogRum.addAction(`Video rendered: ${videos[currentIndex].title}`);
  }, [currentIndex, videos]);

  if (videos.length === 0) return null;

  return (
    <div
      data-test="video-gallery"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "1em",
      }}
    >
      <Button
        data-test="previous-video-button"
        icon="chevron left"
        circular
        onClick={navigateTo("prev")}
        size="huge"
        style={{ color: "white", backgroundColor: "#536DFE" }}
        disabled={currentIndex === 0}
      />
      <div
        style={{
          overflow: "hidden",
          width: width,
          height: height,
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${currentIndex * parseInt(width)}px)`,
          }}
        >
          {videos.map(({ src, title }) => {
            return (
              <div
                key={src}
                style={{ width: width, height: height, flexShrink: 0 }}
              >
                <EmbedVideo
                  src={src}
                  title={title}
                  width={width}
                  height={height}
                />
              </div>
            );
          })}
        </div>
      </div>
      <Button
        data-test="next-video-button"
        icon="chevron right"
        circular
        size="huge"
        style={{ color: "white", backgroundColor: "#536DFE" }}
        onClick={navigateTo("next")}
        disabled={currentIndex === videos.length - 1}
      />
    </div>
  );
}

VideoGallery.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      title: PropTypes.string,
    })
  ),
  width: PropTypes.string,
  height: PropTypes.string,
  initialIndex: PropTypes.number,
};

VideoGallery.defaultProps = {
  videos: [],
  width: "400px",
  height: "225px",
  initialIndex: 1,
};
export default VideoGallery;
